import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"; 
import { useProfile } from "../components/hooks/UserHooks";
import { logoutUser } from "../slices/Thunks";
import { getPermissionsList } from "../slices/veloxity/auth/permissionsManagement/getPermissionList";
import { setAuthorization } from "../helpers/ApiHelper";
import { useLocation } from 'react-router-dom';
import { authProtectedRoutes } from './AllRoutes';

const AuthProtected = ({ children }) => {
  const dispatch = useDispatch();
  const { userProfile, loading } = useProfile();
  const token = userProfile?.data?.accessToken;
  const location = useLocation();

  const { subscriptions } = useSelector(state => state.getPermissionsList);

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
      dispatch(getPermissionsList()); 
    } else if (!userProfile && !loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  const hasFeature = (subscriptionType) => {
    return subscriptions?.some(sub => sub.subscriptionType === subscriptionType);
  };

  // Mevcut route'u bul
  const currentRoute = authProtectedRoutes.find(route => route.path === location.pathname);

  if (!userProfile) {
    return <Navigate to="/login" />; 
  }

  // Bitcoin izni varsa ve route'un hideIfHasFeature özelliği BITCOIN ise erişimi engelle
  if (currentRoute?.hideIfHasFeature === "BITCOIN" && hasFeature("BITCOIN")) {
    return <Navigate to="/bitcoin-analytics" />;
  }

  // Diğer izin kontrolleri
  if (currentRoute?.requiredSubscription && !hasFeature(currentRoute.requiredSubscription)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };